import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPicture = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM20 6L4 6V18H20V6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5179 12.4681C15.4026 11.6939 16.761 11.8461 17.4524 12.7969L20.8087 17.4118C21.1336 17.8585 21.0348 18.4839 20.5882 18.8087C20.1415 19.1336 19.5161 19.0348 19.1913 18.5882L15.8349 13.9732L13.0521 16.4082C12.559 16.8397 11.8858 17.0022 11.25 16.8433L8.21922 16.0856L4.6 18.8C4.15817 19.1314 3.53137 19.0418 3.2 18.6C2.86863 18.1582 2.95817 17.5314 3.4 17.2L7.01922 14.4856C7.50103 14.1242 8.12002 13.9992 8.70429 14.1453L11.7351 14.903L14.5179 12.4681Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11ZM8 12C9.10457 12 10 11.1046 10 10C10 8.89543 9.10457 8 8 8C6.89543 8 6 8.89543 6 10C6 11.1046 6.89543 12 8 12Z",
			fill: "currentColor"
		})
	]
});
export default SvgPicture;
